import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'
import { faFacebookF, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
    return (
        <div className='container-fluid p-5' style={{ marginTop: '80px' }}>
            <div className="row gy-5">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fot-items">
                        <Link to='/'>
                            <img src="https://cdn.10minuteschool.com/images/svg/10mslogo-svg.svg" alt="logo" className='img-fluid' style={{ height: '50px' }} />
                        </Link>
                        <p className='mt-3 mb-3 fs-4'>আমাদের মোবাইল অ্যাপ ডাউনলোড করুন</p>
                        <div className="download-app d-flex align-items-center m-0 p-0">
                            <img src="https://cdn.10minuteschool.com/images/Landing_page/appstore.png" alt="apps" className='img-fluid ' style={{ width: '150px', cursor: 'pointer' }} onClick={() => window.open('https://apps.apple.com/us/app/10-minute-school/id1577061772', '_blank')} />
                            <img src="https://cdn.10minuteschool.com/images/Landing_page/playstore.png" alt="apps" className='img-fluid ms-2 ' style={{ width: '150px', cursor: 'pointer' }} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.a10minuteschool.tenminuteschool', '_blank')} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-12 col-12">
                    <div className="fot-items">
                        <h6 className='text-dark fw-bold mb-3'>কোম্পানি</h6>
                        <div className="fot-link">
                            <ul>
                                <li>
                                    <Link to=''>ক্যারিয়ার</Link>
                                </li>
                                <li>
                                    <Link to=''>প্রাইভেসি পলিসি</Link>
                                </li>
                                <li>
                                    <Link to=''>অ্যাফিলিয়েট হতে চাইলে</Link>
                                </li>
                                <li>
                                    <Link to=''>রিফান্ড পলিসি</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-12 col-12">
                    <div className="fot-items">
                        <h6 className='text-dark fw-bold mb-3'>অন্যান্য</h6>
                        <div className="fot-link">
                            <ul>
                                <li>
                                    <Link to=''>অফার সমূহ</Link>
                                </li>
                                <li>
                                    <Link to=''>নোটস এবং গাইডস</Link>
                                </li>
                                <li>
                                    <Link to=''>ক্র্যাশ কোর্স</Link>
                                </li>
                                <li>
                                    <Link to=''>ব্লগ</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fot-items">
                        <h6 className='text-dark fw-bold mb-3'>আমাদের সাথে যোগাযোগ করুন</h6>
                        <p><span className='text-dark fw-bold fs-5'>কল করুন:</span> 16910 (8AM - 11PM)</p>
                        <p className='mt-2 mb-2'><span className='text-dark fw-bold fs-5'>এসএমএস: </span>10MSHelp to 26969</p>
                        <p><span className='text-dark fw-bold fs-5'>ইমেইল: </span>support@10minuteschool.com</p>
                        <div className="fot-social mt-3">
                            <ul className='d-flex align-items-center justify-content-between w-50 flex-wrap'>
                                <li><a href="https://www.facebook.com/10minuteschool/" target='_blank'><FontAwesomeIcon icon={faFacebookF} className='text-light' /></a></li>
                                <li><a href="https://www.facebook.com/10minuteschool/" target='_blank'><FontAwesomeIcon icon={faTwitter} className='text-light' /></a></li>
                                <li><a href="https://www.facebook.com/10minuteschool/" target='_blank'><FontAwesomeIcon icon={faInstagram} className='text-light' /></a></li>
                                <li><a href="https://www.facebook.com/10minuteschool/" target='_blank'><FontAwesomeIcon icon={faYoutube} className='text-light' /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <p className='text-center mt-5 mb-1 text-secondary fs-5'>স্বত্ব © ২০১৫-২০২২ টেন মিনিট স্কুল কতৃক সর্বস্বত্ব সংরক্ষিত</p>
            </div>
        </div>
    );
};

export default Footer;